/* global google:false */
import angular from 'angular';
import { difference, filter, flatten, map } from 'lodash';

module.exports = angular.module('common.directives.place-autocomplete', [])
.directive('odPlaceAutocomplete', function(Analytics) {
  if (typeof(google) === 'undefined' || !(google.maps && google.maps.places)) {
    console.warn('od-place-autocomplete requires Google Places JavaScript API.');
    return {};
  }

  var autocomplete = new google.maps.places.AutocompleteService()
    , places = new google.maps.places.PlacesService(document.createElement('div'));
  return {
    restrict: 'C', // od-place-autocomplete matches only class name
    scope: { ngModel: '=', }, // isolate scope
    template: require('./place-autocomplete.jade')(),
    link: function(scope, element, attrs) {
      scope.results = [];
      scope.buttonText = attrs.buttonText;
      element.toggleClass('with-button', !!scope.buttonText);

      // Fires from the button if one is present
      scope.fire = function() {
        select(selected || scope.results[0]);
      };

      scope.addressErrors = false;
      // copy placeholder attribute over to input
      var addressAttemptCount = 0,
          input = element.find('input')
        .attr('placeholder', attrs.placeholder);

      // focus the input on autofocus
      if ('autofocus' in attrs)
        input[0].focus();

      // on input change, query google
      var lastQuery;
      scope.$watch('query', function(query) {
        if (!query) return scope.results = [];
        if (selected && selected.description === query) return;

        // Remove commas from query because they hurt our matches
        query = query.replace(/,/g, '');
        lastQuery = query;

        autocomplete.getPlacePredictions({
          input: query,
          types: ['geocode'],
          componentRestrictions: { country: 'us' }
        }, function(results) {
          angular.forEach(results, function(result) {
            result.description = result.description.replace(', United States', '');
          });
          scope.$apply(function() {
            // try to decode what google is returning to filter to only street
            // addresses that we can probably use.
            var hasValidAddressType = function(types) {
              return types.includes('street_address') || types.includes('premise');
            };
            scope.results = filter(results, function(result) {
              return (result.terms.length >= 5 && hasValidAddressType(result.types)) ||
                     (result.terms.length === 4 &&
                      result.terms[0].value.match(/^\d+\S*\s\S+\s/));
            });
          });
        });
      });

      // key bindings for selection
      var key = { left: 37, up: 38, right: 39, down: 40 , tab: 9, enter: 13, esc: 27 }
        , selectedIndex = -1
        , selected = null;
      scope.keydown = function(e) {
        if (input.hasClass('ng-pristine')) return;
        if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) return;

        switch (e.keyCode) {
          case key.down:
            selectedIndex++;
            if (selectedIndex >= scope.results.length)
              selectedIndex = -1;
            break;
          case key.up:
            selectedIndex--;
            if (selectedIndex < -1)
              selectedIndex = scope.results.length-1;
            break;
          case key.esc:
            scope.results = [];
            break;
          case key.enter:
          case key.tab:
            select(selected || scope.results[0]);
            break;
          default:
            return;
        }

        if (!(e.keyCode === key.enter || e.keyCode === key.tab))
          e.preventDefault();

        // unselect previous
        if (selected)
          delete selected.selected;

        selected = scope.results[selectedIndex];
        if (selected) {
          selected.selected = true;
          scope.query = selected.description;
        } else if (selectedIndex === -1) {
          scope.query = lastQuery;
        }
      };

      // click to select
      scope.click = function(result) {
        scope.query = result.description;
        select(result);
      };

      scope.$watch('results', function(results) {
        if (!results || results.length === 0)
          selectedIndex = -1;
      });


      function select(result) {
        if (!result) {
          // we couldn't find that address
          scope.addressErrors = true;
          Analytics.event('address_search', 'submit', 'failed_address_attempt', { eventValue: ++addressAttemptCount }); // eslint-disable-line max-len
        } else {
          places.getDetails(result, function(place) {
            var REQUIRED_COMPONENTS = ['street_number', 'route', 'locality', 'administrative_area_level_1', 'postal_code'], // eslint-disable-line max-len
                foundComponents = flatten(map(place.address_components, 'types'));

            scope.$apply(function() {

              scope.addressErrors = difference(REQUIRED_COMPONENTS, foundComponents).length;
              if (scope.addressErrors) {
                selected = undefined;
                element.find('input')[0].select();
              } else {
                place.query = lastQuery;
                scope.ngModel = place;
              }
            });
          });

          selected = result;
          scope.results = [];
        }
      }
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/place-autocomplete.js
 **/